import { useRef } from 'react';
import type { ReactElement } from 'react';
import classNames from 'classnames';
import type { Statistic } from './Statistics.data';
import { animateNumbers } from './Statistics.transitions';
import styles from './Statistics.module.scss';
import Heading from '../../atoms/heading/Heading';
import useScrollTrigger from '../../../hooks/useScrollTrigger';
import useSetupTimeline from '../../../hooks/useSetupTimeline';

export const AnimatedFigures = ({ stat }: { stat: Statistic }): ReactElement => {
  const numberRef = useRef<HTMLDivElement>(null);

  useScrollTrigger({
    trigger: numberRef,
    animation: useSetupTimeline(animateNumbers, { numberRef }),
    vars: {
      start: 'bottom bottom',
    },
  });

  return (
    <Heading
      as="h3"
      size="heading-03"
      className={classNames(styles.number)}
      disableTriggerInOnScroll={false}
      transitionInType="slideUpFadeIn"
    >
      {stat.unit_left}
      <span ref={numberRef}>{stat.number}</span>
      {stat.unit_right}
    </Heading>
  );
};
